import React, { useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import Gallery from './Gallery';

const Typhoon = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupContentType, setPopupContentType] = useState('');
    const [selectedImage, setSelectedImage] = useState(''); 
  
    const handlePopupOpen = (type, imgSrc) => {
      setPopupContentType(type);
      setSelectedImage(imgSrc); 
      setIsPopupOpen(true);
    };
  
    const handlePopupClose = () => {
      setIsPopupOpen(false);
      setPopupContentType('');
      setSelectedImage('');
    };

    return (
        <section className="t-sec">
          <div className="flex">
            <div className="high-left">
              <h4>Highlight</h4>
              <h5>Οι τρεις σημαντικές επισκέψεις στον «Τυφώνα»</h5>
              <h2>Typhoon</h2>
              <p>Η σημαντικότερη στιγμή για το Ίδρυμα στο 9ο Our Ocean Conference ήταν η επίσκεψη του Πρωθυπουργού της Ελλάδας, Κυριάκου Μητσοτάκη, του Επίτροπου αρμοδίου της Ε.Ε. για το Περιβάλλον, τους Ωκεανούς και την Αλιεία, Virginijus Sinkevičius, και του Υπουργού Ναυτιλίας και Νησιωτικής Πολιτικής, Χρήστου Στυλιανίδη στον «Τυφώνα». Ξεναγήθηκαν στο κατάστρωμα και στη γέφυρα του πλοίου από την Πρόεδρο του Ιδρύματος, Εύη Λαζού-Λασκαρίδη, και ενημερώθηκαν για τις δυνατότητές του και το τακτικό ερευνητικό έργο που πραγματοποιεί.</p>
            </div>
            <div className="high-right">
              <Swiper navigation={true} modules={[Navigation]} className="highSwiper">
                <SwiperSlide>
                  <img 
                    src="img/typhoon/IMG_0188.jpg" 
                    alt="typhoon" 
                    className="popup-trigger" 
                    onClick={() => handlePopupOpen('typhoon', 'img/typhoon/IMG_0188.jpg')}
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img 
                    src="img/typhoon/659b75b3-738b-4110-83e5-bb0d714e11c0.jpg" 
                    alt="typhoon" 
                    className="popup-trigger" 
                    onClick={() => handlePopupOpen('typhoon', 'img/typhoon/659b75b3-738b-4110-83e5-bb0d714e11c0.jpg')}
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img 
                    src="img/typhoon/9a3830f6-bf6a-4b34-82ba-2950047d85e2.jpg" 
                    alt="typhoon" 
                    className="popup-trigger" 
                    onClick={() => handlePopupOpen('typhoon', 'img/typhoon/9a3830f6-bf6a-4b34-82ba-2950047d85e2.jpg')}
                  /> 
                </SwiperSlide>
                <SwiperSlide>
                  <img 
                    src="img/typhoon/DSCF2815.jpg" 
                    alt="typhoon" 
                    className="popup-trigger" 
                    onClick={() => handlePopupOpen('typhoon', 'img/typhoon/DSCF2815.jpg')}
                  />
                </SwiperSlide>
              </Swiper>
              <Gallery 
                isOpen={isPopupOpen} 
                contentType={popupContentType} 
                selectedImage={selectedImage} 
                onClose={handlePopupClose} 
              />
            </div>
          </div>
        </section>
      );
    };
    
    export default Typhoon;
    